import { TeamNameFormatter } from '../helpers/FormattingHelpers';

const ResponsiveTeamName = ({ team, minSize = 'shortened', maxSize }) => {
    const { name_display_variations, name } = team || {};

    // Check if name_display_variations has the expected structure (full_name, shortened_name, abbreviated_name)
    // If it has team object keys (id, image), it's malformed and we should derive from name instead
    const hasValidDisplayVariations = name_display_variations &&
        typeof name_display_variations === 'object' &&
        ('full_name' in name_display_variations || 'shortened_name' in name_display_variations || 'abbreviated_name' in name_display_variations);

    // Use name_display_variations if valid, otherwise derive from team.name
    const displayVariations = hasValidDisplayVariations ? name_display_variations : TeamNameFormatter(name);
    const { full_name, shortened_name, abbreviated_name } = displayVariations;

    if (maxSize === 'abbreviated') {
        return <span>{abbreviated_name}</span>;
    }

    if (maxSize === 'shortened') {
        if (minSize === 'shortened') {
            return <span>{shortened_name}</span>;
        }
        return (
            <>
                <span className="d-none d-lg-inline">{shortened_name}</span>
                <span className="d-inline d-lg-none">{abbreviated_name}</span>
            </>
        );
    }

    // maxSize === 'full' or undefined (default behavior)
    if (minSize === 'full') {
        return <span>{full_name}</span>;
    }

    if (minSize === 'shortened') {
        return (
            <>
                <span className="d-none d-lg-inline">{full_name}</span>
                <span className="d-inline d-lg-none">{shortened_name}</span>
            </>
        );
    }

    return (
        <>
            <span className="d-none d-lg-inline">{full_name}</span>
            <span className="d-none d-sm-inline d-lg-none">{shortened_name}</span>
            <span className="d-inline d-sm-none">{abbreviated_name}</span>
        </>
    );
};

export default ResponsiveTeamName;
